//modal para editar/crear tarifas, se usa dentro de los pasos de creacion de un evento. 
//permite crear o editar una tarifa creada dentro de los pasos
import {
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
  Box,
  Tooltip
} from "@mui/material";
import { styled } from '@mui/material/styles';
import { Delete, Close, InfoOutlined } from "@mui/icons-material";
import moment from 'moment-timezone';

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#5656ff',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

const CustomCheckbox = styled('span')(({ theme }) => ({
  borderRadius: 3,
  width: 16,
  height: 16,
  boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor: '#fff',
  backgroundImage: '#fff',
  '.Mui-focusVisible &': {
    outline: '2px auto #5656ff',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: '#5656ff',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background: 'rgba(206,217,224,.5)',
  },
}));

const CustomCheckboxChecked = styled(CustomCheckbox)({
  backgroundColor: '#5656ff',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&::before': {
    display: 'block',
    width: 16,
    height: 16,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: '#106ba3',
  },
});

const CreateEditTarifa = ({
  modalOpen,
  handleCloseModal,
  tipoSeleccionado,
  tarifaActual,
  formData,
  setFormData,
  formErrors,
  fechasEvento,
  ubicaciones,
  preguntas,
  setPreguntas,
  checked,
  handleChange,
  handleChangeVisivilidad,
  handleCheckboxChange,
  handleCheckboxChange2,
  handleCheckboxChange3,
  handlePreguntaChange,
  agregarPregunta,
  eliminarPregunta,
  handleSubmit
}) => {
  return (
    <Dialog
      open={modalOpen}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleCloseModal();
        }
      }}
      disableEscapeKeyDown
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h5" sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0062" }}>
            {tarifaActual ? "Editar tarifa tipo" : "Crear tarifa - "} {tipoSeleccionado === 'tickets' ? 'Ticket' : 'Consumición'}
          </Typography>
          <IconButton onClick={handleCloseModal}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <form id="tarifaForm" onSubmit={handleSubmit}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <FormControl
                sx={{
                  minWidth: 200,
                  mr: 2,
                  '& .MuiOutlinedInput-root': {
                    fontFamily: "Bricolage Grotesque",
                    '& fieldset': {
                      borderColor: '#B2BAC2',
                    },
                    '&:hover fieldset': {
                      borderColor: '#5656ff',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#5656ff',
                    },
                    height: "40px",
                  },
                  '& .MuiFormHelperText-root': {
                    fontFamily: "Bricolage Grotesque",
                  }
                }}
                fullWidth margin="dense">
                <Typography variant="p" sx={{ mb: 1, color: "#0b0062" }}>Elige la visibilidad de tus tarifas <span style={{ color: "red" }}>*</span></Typography>
                <Select
                  sx={{
                    backgroundColor: "#ffff",
                    '& .MuiSelect-select': {
                      padding: "8px 14px",
                      display: 'flex',
                      alignItems: 'center',
                      height: "24px",
                    }
                  }}
                  labelId="privado-label"
                  id="privado"
                  name="privado"
                  value={formData.privado?.toString() || "false"}
                  onChange={handleChangeVisivilidad}
                >
                  <MenuItem value="true">Privado</MenuItem>
                  <MenuItem value="false">Público</MenuItem>
                </Select>
                <FormHelperText>
                  {formData.privado === false ?
                    "Las tarifas públicas serán visibles para el público y estarán disponibles para la venta."
                    : "Las tarifas privadas no se mostrarán al público ni estarán disponibles para la venta."
                  }
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="p" sx={{ mb: 1, color: "#0b0062" }}>Nombre de tu tarifa <span style={{ color: "red" }}>*</span></Typography>
              <TextField
                sx={{
                  fontFamily: "Bricolage Grotesque",
                  mb: 2,
                  '& .MuiInputBase-input-MuiOutlinedInput-input': {
                    fontFamily: "Bricolage Grotesque",
                  },
                  '& label.Mui-focused': {
                    color: '#5656FF',
                    fontFamily: "Bricolage Grotesque"
                  },
                  '& .MuiOutlinedInput-root': {
                    height: "40px",

                    '& fieldset': {
                      borderColor: '#B2BAC2',
                    },
                    '&:hover fieldset': {
                      borderColor: '#5656ff',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#5656ff',
                    },
                  }
                }}
                variant="outlined"
                fullWidth
                name="concepto"
                value={formData.concepto || ''}
                onChange={handleChange}
                margin="dense"
                error={formErrors?.concepto}
                helperText={formErrors?.concepto ? 'Este campo es obligatorio' : ''}
                required
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="p" sx={{ mb: 1, color: "#0b0062" }}>Precio <span style={{ color: "red" }}>*</span></Typography>
              <TextField
                sx={{
                  fontFamily: "Bricolage Grotesque",
                  mb: 2,
                  '& .MuiInputBase-input-MuiOutlinedInput-input': {
                    fontFamily: "Bricolage Grotesque",
                  },
                  '& label.Mui-focused': {
                    color: '#5656FF',
                    fontFamily: "Bricolage Grotesque"
                  },
                  '& .MuiOutlinedInput-root': {
                    height: "40px",
                    '& fieldset': {
                      borderColor: '#B2BAC2',
                    },
                    '&:hover fieldset': {
                      borderColor: '#5656ff',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#5656ff',
                    },
                  }
                }}
                variant="outlined"
                fullWidth
                name="precio"
                onChange={handleChange}
                value={formData.precio || ''}
                margin="dense"
                type="number"
                InputProps={{
                  startAdornment: <Typography sx={{ mr: 1 }}>$</Typography>
                }}
              />
            </Grid>

            <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: "column" }}>
              {formData.precio > 0 && (
                <>
                  <Typography variant="p" sx={{ mb: 1, display: 'block', color: "#0b0062" }}>
                    Costos de comisión
                  </Typography>
                  <div className="d-flex flex-row align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          icon={<CustomCheckbox />}
                          checkedIcon={<CustomCheckboxChecked />}
                          checked={formData.asumir_comision || false}
                          onChange={handleCheckboxChange}
                        />
                      }
                      label={
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          Asumir costos
                          <Tooltip title="Al asumir la comisión, vos como organizador 
                          pagas los cargos por servicio y el 
                          comprador verá exactamente el precio que 
                          estableciste." arrow placement="top">
                            <InfoOutlined
                              fontSize="small"
                              sx={{ ml: 1, color: '#5656ff', cursor: 'help' }}
                            />
                          </Tooltip>
                        </Box>
                      }
                    />
                  </div>
                </>
              )}
            </Grid>

            {!formData.privado && (
              <>
                <Typography variant="p" sx={{ ml: 1, mt: 1, display: 'block', color: "#0b0062" }}>
                  ¿Cuándo querés que inicie y finalice la venta? <span style={{ color: "red" }}>*</span>
                </Typography>
                <Grid item xs={12} md={6}>
                  <TextField
                    sx={{
                      fontFamily: "Bricolage Grotesque",
                      mb: 2,
                      '& .MuiInputBase-input-MuiOutlinedInput-input': {
                        fontFamily: "Bricolage Grotesque",
                      },
                      '& label.Mui-focused': {
                        color: '#5656FF',
                        fontFamily: "Bricolage Grotesque"
                      },
                      '& .MuiOutlinedInput-root': {
                        height: "40px",
                        '& fieldset': {
                          borderColor: '#B2BAC2',
                        },
                        '&:hover fieldset': {
                          borderColor: '#5656ff',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#5656ff',
                        },
                      }
                    }}
                    label="Día de inicio"
                    type="date"
                    name="inicio_venta_fecha"
                    value={formData.inicio_venta_fecha || ''}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    margin="dense"
                    required
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    sx={{
                      fontFamily: "Bricolage Grotesque",
                      mb: 2,
                      '& .MuiInputBase-input-MuiOutlinedInput-input': {
                        fontFamily: "Bricolage Grotesque",
                      },
                      '& label.Mui-focused': {
                        color: '#5656FF',
                        fontFamily: "Bricolage Grotesque"
                      },
                      '& .MuiOutlinedInput-root': {
                        height: "40px",
                        '& fieldset': {
                          borderColor: '#B2BAC2',
                        },
                        '&:hover fieldset': {
                          borderColor: '#5656ff',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#5656ff',
                        },
                      }
                    }}
                    label="Hora de inicio"
                    type="time"
                    name="inicio_venta_hora"
                    value={formData.inicio_venta_hora || ''}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    margin="dense"
                    required
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    sx={{
                      fontFamily: "Bricolage Grotesque",
                      mb: 2,
                      '& .MuiInputBase-input-MuiOutlinedInput-input': {
                        fontFamily: "Bricolage Grotesque",
                      },
                      '& label.Mui-focused': {
                        color: '#5656FF',
                        fontFamily: "Bricolage Grotesque"
                      },
                      '& .MuiOutlinedInput-root': {
                        height: "40px",
                        '& fieldset': {
                          borderColor: '#B2BAC2',
                        },
                        '&:hover fieldset': {
                          borderColor: '#5656ff',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#5656ff',
                        },
                      }
                    }}
                    label="Día de finalización"
                    type="date"
                    name="fin_venta_fecha"
                    value={formData.fin_venta_fecha || ''}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    margin="dense"
                    required
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    sx={{
                      fontFamily: "Bricolage Grotesque",
                      mb: 2,
                      '& .MuiInputBase-input-MuiOutlinedInput-input': {
                        fontFamily: "Bricolage Grotesque",
                      },
                      '& label.Mui-focused': {
                        color: '#5656FF',
                        fontFamily: "Bricolage Grotesque"
                      },
                      '& .MuiOutlinedInput-root': {
                        height: "40px",
                        '& fieldset': {
                          borderColor: '#B2BAC2',
                        },
                        '&:hover fieldset': {
                          borderColor: '#5656ff',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#5656ff',
                        },
                      }
                    }}
                    label="Hora de finalización"
                    type="time"
                    name="fin_venta_hora"
                    value={formData.fin_venta_hora || ''}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    margin="dense"
                    required
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12}>
              <Typography variant="p" sx={{ mb: 1, display: 'block', color: "#0b0062" }}>
                ¿A qué fecha de tu evento corresponde la tarifa? <span style={{ color: "red" }}>*</span>
              </Typography>
              <FormControl
                sx={{
                  minWidth: 200,
                  mr: 2,
                  '& .MuiOutlinedInput-root': {
                    fontFamily: "Bricolage Grotesque",
                    '& fieldset': {
                      borderColor: '#B2BAC2',
                    },
                    '&:hover fieldset': {
                      borderColor: '#5656ff',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#5656ff',
                    },
                    height: "40px",
                  },
                  '& .MuiFormHelperText-root': {
                    fontFamily: "Bricolage Grotesque",
                  }
                }}
                fullWidth margin="dense" error={formErrors?.fechas}>
                <Select
                  sx={{
                    backgroundColor: "#ffff",
                    '& .MuiSelect-select': {
                      padding: "8px 14px",
                      display: 'flex',
                      alignItems: 'center',
                      height: "24px",
                    }
                  }}
                  multiple
                  name="fechas"
                  onChange={handleChange}
                  value={formData.fechas || []}
                  renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {selected.map((value) => {
                        const selectedOption = fechasEvento.find((opt) => opt.id === value);
                        return <Chip key={value} label={moment(selectedOption?.hora_inicio).clone().local().format("lll")} />;
                      })}
                    </Box>
                  )}
                  required
                >
                  {fechasEvento?.map((item) => (
                    <MenuItem
                      key={item.id}
                      value={item.id}
                    >
                      <Checkbox checked={formData.fechas?.includes(item.id)} />
                      {moment(item.fecha).clone().local().format("D [de] MMMM Y")}
                    </MenuItem>
                  ))}
                </Select>
                {formErrors?.fechas && <FormHelperText>Selecciona al menos una fecha</FormHelperText>}
              </FormControl>
            </Grid>

            {tipoSeleccionado === 'tickets' && (
              <>
                <Grid item xs={12}>
                  <div className='mt-1 d-flex flex-column gap-2'>
                    <Typography variant="p" sx={{ display: 'block', color: "#0b0062" }}>
                      Ubicación <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <span style={{ fontSize: "12px", color: "#7B7C88" }}>
                      Cada tarifa debe estar vinculada a una ubicación. Esto te permite definir el máximo de entradas por persona y el total disponible para esa tarifa.<br />Ejemplo: Tarifa General → Ubicación: General / Tarifa VIP → Ubicación: VIP.
                    </span>
                    {/* <Tooltip title="Todas las tarifas deben contar con una ubicación para manejar los límites de compra por comprador y los límites máximos de la tarifa." arrow placement="top">
                      <InfoOutlined
                        fontSize="small"
                        sx={{ ml: 1, color: '#5656ff', cursor: 'help' }}
                      />
                    </Tooltip> */}
                  </div>

                  <FormControl fullWidth margin="dense" sx={{ ml: 1 }}>
                    <FormControlLabel
                      control={
                        <CustomSwitch
                          sx={{ mr: 2 }}
                          checked={formData.nueva_ubicacion || false}
                          onChange={(e) => setFormData({
                            ...formData,
                            nueva_ubicacion: e.target.checked,
                            idubicacion: e.target.checked ? '' : formData.idubicacion
                          })}
                        />
                      }
                      label="Crear nueva ubicación"
                    />
                  </FormControl>
                </Grid>

                {formData.nueva_ubicacion ? (
                  <>
                    <Grid item xs={12} sx={{ paddingTop: 0 }}>
                      <Typography variant="p" sx={{ mb: 0, display: 'block', color: "#0b0062", fontSize: "14px" }}>Nombre de la ubicación</Typography>
                      <TextField
                        sx={{
                          fontFamily: "Bricolage Grotesque",
                          mb: 2,
                          '& .MuiInputBase-input-MuiOutlinedInput-input': {
                            fontFamily: "Bricolage Grotesque",
                          },
                          '& label.Mui-focused': {
                            color: '#5656FF',
                            fontFamily: "Bricolage Grotesque"
                          },
                          '& .MuiOutlinedInput-root': {
                            height: "40px",
                            '& fieldset': {
                              borderColor: '#B2BAC2',
                            },
                            '&:hover fieldset': {
                              borderColor: '#5656ff',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#5656ff',
                            },
                          }
                        }}
                        variant="outlined"
                        fullWidth
                        name="nombre_ubicacion"
                        value={formData.nombre_ubicacion || ''}
                        onChange={handleChange}
                        margin="dense"
                        required
                        error={formErrors?.nombre_ubicacion}
                        helperText={formErrors?.nombre_ubicacion ? 'Este campo es obligatorio' : ''}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        sx={{
                          fontFamily: "Bricolage Grotesque",
                          mb: 2,
                          '& .MuiInputBase-input-MuiOutlinedInput-input': {
                            fontFamily: "Bricolage Grotesque",
                          },
                          '& label.Mui-focused': {
                            color: '#5656FF',
                            fontFamily: "Bricolage Grotesque"
                          },
                          '& .MuiOutlinedInput-root': {
                            height: "40px",
                            '& fieldset': {
                              borderColor: '#B2BAC2',
                            },
                            '&:hover fieldset': {
                              borderColor: '#5656ff',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#5656ff',
                            },
                          }
                        }}
                        label="Límite de compra por comprador"
                        variant="outlined"
                        fullWidth
                        name="limite_persona"
                        onChange={handleChange}
                        value={formData.limite_persona || ''}
                        margin="dense"
                        type="number"
                        error={!!formErrors?.limite_persona}
                        helperText={formErrors?.limite_persona ? 'Este campo es obligatorio' : ''}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        sx={{
                          fontFamily: "Bricolage Grotesque",
                          mb: 2,
                          '& .MuiInputBase-input-MuiOutlinedInput-input': {
                            fontFamily: "Bricolage Grotesque",
                          },
                          '& label.Mui-focused': {
                            color: '#5656FF',
                            fontFamily: "Bricolage Grotesque"
                          },
                          '& .MuiOutlinedInput-root': {
                            height: "40px",
                            '& fieldset': {
                              borderColor: '#B2BAC2',
                            },
                            '&:hover fieldset': {
                              borderColor: '#5656ff',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#5656ff',
                            },
                          }
                        }}
                        label="Límite máximo de entradas"
                        variant="outlined"
                        fullWidth
                        name="limite_maximo"
                        onChange={handleChange}
                        value={formData.limite_maximo || ''}
                        margin="dense"
                        type="number"
                        error={formErrors?.limite_maximo}
                        helperText={formErrors?.limite_maximo ? 'Este campo es obligatorio' : ''}
                        required
                      />
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={12} sx={{ pt: "0 !important" }}>
                    <FormControl sx={{
                      minWidth: 200,
                      mr: 2,
                      '& .MuiOutlinedInput-root': {
                        fontFamily: "Bricolage Grotesque",
                        '& fieldset': {
                          borderColor: '#B2BAC2',
                        },
                        '&:hover fieldset': {
                          borderColor: '#5656ff',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#5656ff',
                        },
                        height: "40px",
                      },
                      '& .MuiFormHelperText-root': {
                        fontFamily: "Bricolage Grotesque",
                      }
                    }}
                      fullWidth margin="dense" error={formErrors?.idubicacion}>
                      <Select
                        sx={{
                          backgroundColor: "#ffff",
                          '& .MuiSelect-select': {
                            padding: "8px 14px",
                            display: 'flex',
                            alignItems: 'center',
                            height: "24px",
                          }
                        }}
                        name="idubicacion"
                        value={formData.idubicacion || ''}
                        onChange={handleChange}
                        required
                      >
                        {ubicaciones?.map((ubicacion) => (
                          <MenuItem key={ubicacion.id} value={ubicacion.id}>
                            {ubicacion.ubicacion}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText>
                        {formErrors?.idubicacion && 'Debes seleccionar una ubicación'}
                        {ubicaciones?.length === 0 && 'No hay ubicaciones creadas'}
                      </FormHelperText>
                    </FormControl>
                    {formData.idubicacion && (
                      <Box sx={{ mt: 2, mb: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                        <Typography variant="body2">
                          <strong>Límites de la ubicación seleccionada:</strong>
                        </Typography>
                        <Typography variant="body2">
                          Límite por persona: {ubicaciones?.find(u => u.id === parseInt(formData.idubicacion))?.limitepersona || 'N/A'}
                        </Typography>
                        <Typography variant="body2">
                          Límite máximo: {ubicaciones?.find(u => u.id === parseInt(formData.idubicacion))?.limitemaximo || 'N/A'}
                        </Typography>
                      </Box>
                    )}
                  </Grid>
                )}
              </>
            )}

            {tipoSeleccionado === 'consumicion' && (
              <div className='d-flex flex-column gap-2 ml-1 mt-3  w-100'>
                <Typography variant="p" sx={{ display: 'block', color: "#0b0062" }}>
                  Límites de venta <span style={{ color: "red" }}>*</span>
                </Typography>
                <div className='d-flex flex-row justify-content-between align-items-center gap-2'>
                  <Grid item xs={12} md={6}>
                    <TextField
                      sx={{
                        fontFamily: "Bricolage Grotesque",
                        mb: 2,
                        '& .MuiInputBase-input-MuiOutlinedInput-input': {
                          fontFamily: "Bricolage Grotesque",
                        },
                        '& label.Mui-focused': {
                          color: '#5656FF',
                          fontFamily: "Bricolage Grotesque"
                        },
                        '& .MuiOutlinedInput-root': {
                          height: "40px",
                          '& fieldset': {
                            borderColor: '#B2BAC2',
                          },
                          '&:hover fieldset': {
                            borderColor: '#5656ff',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#5656ff',
                          },
                        }
                      }}
                      label="Límite de compra por comprador"
                      variant="outlined"
                      fullWidth
                      name="limite_persona"
                      onChange={handleChange}
                      value={formData.limite_persona || ''}
                      margin="dense"
                      type="number"
                      error={!!formErrors?.limite_persona}
                      helperText={formErrors?.limite_persona ? 'Este campo es obligatorio' : ''}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      sx={{
                        fontFamily: "Bricolage Grotesque",
                        mb: 2,
                        '& .MuiInputBase-input-MuiOutlinedInput-input': {
                          fontFamily: "Bricolage Grotesque",
                        },
                        '& label.Mui-focused': {
                          color: '#5656FF',
                          fontFamily: "Bricolage Grotesque"
                        },
                        '& .MuiOutlinedInput-root': {
                          height: "40px",
                          '& fieldset': {
                            borderColor: '#B2BAC2',
                          },
                          '&:hover fieldset': {
                            borderColor: '#5656ff',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#5656ff',
                          },
                        }
                      }}
                      label="Límite máximo de vouchers"
                      variant="outlined"
                      fullWidth
                      name="limite_maximo"
                      onChange={handleChange}
                      value={formData.limite_maximo || ''}
                      margin="dense"
                      type="number"
                      error={formErrors?.limite_maximo}
                      helperText={formErrors?.limite_maximo ? 'Este campo es obligatorio' : ''}
                      required
                    />
                  </Grid>
                </div>
              </div>
            )}

            {tipoSeleccionado === 'tickets' && (
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      icon={<CustomCheckbox />}
                      checkedIcon={<CustomCheckboxChecked />}
                      checked={formData.informacion_adicional || false}
                      onChange={handleCheckboxChange2}
                    />
                  }
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      Solicitar información adicional
                      <Tooltip title="¿Necesitás información extra de cada comprador? Hacé check acá y cargá tus preguntas" arrow placement="top">
                        <InfoOutlined
                          fontSize="small"
                          sx={{ ml: 1, color: '#5656ff', cursor: 'help' }}
                        />
                      </Tooltip>
                    </Box>
                  }
                  margin="dense"
                />

                {formData.informacion_adicional && (
                  <Box sx={{ mt: 1 }}>
                    {preguntas.map((pregunta, index) => (
                      <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                        <TextField
                          sx={{
                            fontFamily: "Bricolage Grotesque",
                            mb: 1,
                            '& .MuiInputBase-input-MuiOutlinedInput-input': {
                              fontFamily: "Bricolage Grotesque",
                            },
                            '& label.Mui-focused': {
                              color: '#5656FF',
                              fontFamily: "Bricolage Grotesque"
                            },
                            '& .MuiOutlinedInput-root': {
                              height: "40px",
                              '& fieldset': {
                                borderColor: '#B2BAC2',
                              },
                              '&:hover fieldset': {
                                borderColor: '#5656ff',
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: '#5656ff',
                              },
                            }
                          }}
                          label="Pregunta"
                          value={pregunta.informacion_adicional}
                          onChange={(e) => handlePreguntaChange(index, e.target.value)}
                          fullWidth
                          size="small"
                          margin="dense"
                        />
                        {preguntas.length > 1 && (
                          <IconButton
                            aria-label="delete"
                            color="error"
                            onClick={() => eliminarPregunta(index)}
                          >
                            <Delete />
                          </IconButton>
                        )}
                      </Box>
                    ))}

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                      <Button
                        variant="text"
                        onClick={agregarPregunta}
                        disabled={preguntas[preguntas.length - 1]?.informacion_adicional?.trim() === ""}
                      >
                        Agregar +
                      </Button>
                    </Box>
                  </Box>
                )}
              </Grid>
            )}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    icon={<CustomCheckbox />}
                    checkedIcon={<CustomCheckboxChecked />}
                    checked={formData.preimpreso || false}
                    onChange={handleCheckboxChange3}
                  />
                }
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    Tickets preimpresos
                    <Tooltip title="Marca esta opción si utilizarás tickets físicos preimpresos para este evento" arrow placement="top">
                      <InfoOutlined
                        fontSize="small"
                        sx={{ ml: 1, color: '#5656ff', cursor: 'help' }}
                      />
                    </Tooltip>
                  </Box>
                }
                margin="dense"
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions sx={{ padding: "16px", display: "flex", flexWrap: "wrap", gap: "10px" }}>
        <Button sx={{
          border: "1px solid #5656FF",
          color: "#5656FF",
          padding: "5px 10px",
          borderRadius: "4px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: window.innerWidth <= 576 ? "13px" : "14px",
          width: "100%",
        }} onClick={handleCloseModal}>Cancelar</Button>
        <Button
          type="submit"
          form="tarifaForm"
          variant="contained"
          sx={{
            marginLeft: "0 !important",
            backgroundColor: "#5656FF",
            color: "white",
            padding: "5px 10px",
            borderRadius: "4px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: window.innerWidth <= 576 ? "13px" : "14px",
            width: "100%"
          }}
        >
          {tarifaActual ? "Editar tarifa - " : "Crear tarifa - "} {tipoSeleccionado === 'tickets' ? 'Ticket' : 'Consumición'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CreateEditTarifa;